import { get } from '@webapp-next/lib/request/webapp/apiv2';

type EligibilityCheckBody = {
  hr?: boolean;
  ess?: boolean;
  sentiment?: boolean;
  docLibrary?: boolean;
  manageEss?: boolean;
};

type EligibilityCheckResponse = {
  success: boolean;
  eligibility: {
    hr: boolean;
    ess: boolean;
    sentiment: boolean;
    docLibrary: boolean;
    manageEss: boolean;
  };
};

export default async function getHrEligibilityCheck(
  body: EligibilityCheckBody
): Promise<EligibilityCheckResponse> {
  const { data } = await get('/api/hr/v2/settings/eligibility', {
    params: body,
  });

  return data;
}
